import React from 'react';
import { getQueryValue } from '../../utils/route';
import CookieRoute from './CookieRoute';
import { FILE_NOT_FOUND } from '../../api/redux-route/routes';
import PrivateContentRenderer from './PrivateContentRenderer';

const hasTokenVar = getQueryValue('token');

export default class TokenRoute extends React.Component {
  render() {
    return (
      <CookieRoute
        path={this.props.path}
        exact={this.props.exact}
        render={routeProps => (
          <PrivateContentRenderer
            hasAccess={hasTokenVar}
            redirectTo={FILE_NOT_FOUND}
            render={this.props.render}
            component={this.props.component}
            innerProps={routeProps}
          />
        )}
      />
    );
  }
}
